/*
 * Copyright (c) 2023-2024 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
 /**
 * Yesan platform internationalization NLS mapping
 * @class YSNLS
 * @author Vincent BONESTEVE
 */
export default class YSNLS {
  /**
   * NLS supported languages
   * @static
   */
  static SUPPORTED_LANGS = ['bg','cs','da','de','el','en','es','et','fi','fr','hu','id','it','ja','ko','lt','lv','nb','nl','pl','pt','pt-BR','ro','ru','sk','sv','tr','uk','zh'];//'sl'

  static flagRemap(lang){
    let out="";
    switch (lang){
      case 'cs':
        out='cz';
        break;
      case 'da':
        out='dk';
        break;
      case 'el':
        out='gr';
        break;
      case 'en':
        out='us';
        break;
      case 'ja':
        out='jp';
        break;
      case 'ko':
        out='kr';
        break;
      case 'nb':
        out='no';
        break;
      case 'pt-BR':
        out='br';
        break;
      case 'uk':
        out='ua';
        break;
      case 'zh':
        out='cn';
        break;
      default:
        out=lang;
        break;

    }
    return out;
  }
  /**
   * NLS mapping
   * @static
   */
  static s = {
    "en": require('YS/nls/locales/en.js').translation,
    "bg": require('YS/nls/locales/bg.js').translation,
    "cs": require('YS/nls/locales/cs.js').translation,
    "da": require('YS/nls/locales/da.js').translation,
    "de": require('YS/nls/locales/de.js').translation,
    "el": require('YS/nls/locales/el.js').translation,
    "es": require('YS/nls/locales/es.js').translation,
    "et": require('YS/nls/locales/et.js').translation,
    "fi": require('YS/nls/locales/fi.js').translation,
    "fr": require('YS/nls/locales/fr.js').translation,
    "hu": require('YS/nls/locales/hu.js').translation,
    "id": require('YS/nls/locales/id.js').translation,
    "it": require('YS/nls/locales/it.js').translation,
    "ja": require('YS/nls/locales/ja.js').translation,
    "ko": require('YS/nls/locales/ko.js').translation,
    "lt": require('YS/nls/locales/lt.js').translation,
    "lv": require('YS/nls/locales/lv.js').translation,
    "nb": require('YS/nls/locales/nb.js').translation,
    "nl": require('YS/nls/locales/nl.js').translation,
    "pl": require('YS/nls/locales/pl.js').translation,
    "pt": require('YS/nls/locales/pt.js').translation,
    "pt-BR": require('YS/nls/locales/pt-BR.js').translation,
    "ro": require('YS/nls/locales/ro.js').translation,
    "ru": require('YS/nls/locales/ru.js').translation,
    "sk": require('YS/nls/locales/sk.js').translation,
    "sv": require('YS/nls/locales/sv.js').translation,
    "tr": require('YS/nls/locales/tr.js').translation,
    "uk": require('YS/nls/locales/uk.js').translation,
    "zh": require('YS/nls/locales/zh.js').translation
  }

  /**
   * NLS documents mapping
   * @static
   */
  static documents = {
    "en": require('YS/nls/locales/en.js').documents,
    "bg": require('YS/nls/locales/bg.js').documents,
    "cs": require('YS/nls/locales/cs.js').documents,
    "da": require('YS/nls/locales/da.js').documents,
    "de": require('YS/nls/locales/de.js').documents,
    "el": require('YS/nls/locales/el.js').documents,
    "es": require('YS/nls/locales/es.js').documents,
    "et": require('YS/nls/locales/et.js').documents,
    "fi": require('YS/nls/locales/fi.js').documents,
    "fr": require('YS/nls/locales/fr.js').documents,
    "hu": require('YS/nls/locales/hu.js').documents,
    "id": require('YS/nls/locales/id.js').documents,
    "it": require('YS/nls/locales/it.js').documents,
    "ja": require('YS/nls/locales/ja.js').documents,
    "ko": require('YS/nls/locales/ko.js').documents,
    "lt": require('YS/nls/locales/lt.js').documents,
    "lv": require('YS/nls/locales/lv.js').documents,
    "nb": require('YS/nls/locales/nb.js').documents,
    "nl": require('YS/nls/locales/nl.js').documents,
    "pl": require('YS/nls/locales/pl.js').documents,
    "pt": require('YS/nls/locales/pt.js').documents,
    "pt-BR": require('YS/nls/locales/pt-BR.js').documents,
    "ro": require('YS/nls/locales/ro.js').documents,
    "ru": require('YS/nls/locales/ru.js').documents,
    "sk": require('YS/nls/locales/sk.js').documents,
    "sv": require('YS/nls/locales/sv.js').documents,
    "tr": require('YS/nls/locales/tr.js').documents,
    "uk": require('YS/nls/locales/uk.js').documents,
    "zh": require('YS/nls/locales/zh.js').documents
  }

}
